// Kaart op de horeca-pand detailpagina (De Brabandere): rode pin + wit adres-kaartje (popup),
// conform design. Adres wordt client-side gegeocodeerd via Nominatim (OSM).
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { addBasemap } from "./openfreemap.js";

const PIN =
    '<svg width="28" height="39" viewBox="0 0 13 18" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M5.71094 16.668C0.863281 9.69531 0 8.96484 0 6.375C0 2.85547 2.82227 0 6.375 0C9.89453 0 12.75 2.85547 12.75 6.375C12.75 8.96484 11.8535 9.69531 7.00586 16.668C6.70703 17.1328 6.00977 17.1328 5.71094 16.668ZM6.375 9.03125C7.83594 9.03125 9.03125 7.86914 9.03125 6.375C9.03125 4.91406 7.83594 3.71875 6.375 3.71875C4.88086 3.71875 3.71875 4.91406 3.71875 6.375C3.71875 7.86914 4.88086 9.03125 6.375 9.03125Z" fill="#DE331C"/></svg>';

const escapeHtml = (text) => {
    const el = document.createElement("span");
    el.textContent = String(text);
    return el.innerHTML;
};

const initPandMap = () => {
    const el = document.getElementById("pand-map");
    if (!el || el.dataset.init) return;
    el.dataset.init = "1";

    const map = L.map(el, { scrollWheelZoom: false, zoomControl: false, attributionControl: true });
    L.control.zoom({ position: "bottomright" }).addTo(map);
    addBasemap(map);

    const icon = L.divIcon({ html: PIN, className: "pand-marker", iconSize: [28, 39], iconAnchor: [14, 39], popupAnchor: [0, -36] });
    const balloon =
        '<strong class="pand-pop__title">' + escapeHtml(el.dataset.title || "") + "</strong>" +
        '<span class="pand-pop__addr">' + escapeHtml(el.dataset.label || "") + "</span>";

    const place = (lat, lng, zoom) => {
        map.setView([lat, lng], zoom || 15);
        L.marker([lat, lng], { icon })
            .addTo(map)
            .bindPopup(balloon, { className: "pand-pop", closeButton: false, offset: [0, -2], minWidth: 220 })
            .openPopup();
    };

    // Geocode het adres; val terug op de regio Harelbeke als het niet lukt.
    fetch("https://nominatim.openstreetmap.org/search?format=json&limit=1&q=" + encodeURIComponent(el.dataset.address), { headers: { Accept: "application/json" } })
        .then((r) => r.json())
        .then((d) => {
            if (d && d.length) place(parseFloat(d[0].lat), parseFloat(d[0].lon), 15);
            else place(50.853, 3.312, 12);
        })
        .catch(() => place(50.853, 3.312, 12));
};

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initPandMap);
} else {
    initPandMap();
}
